import { Status } from '../../../../shared/enums/status.enum';
import { UtilHelper } from '../../../../shared/helpers/utils.helper';
import { Translation } from '../../../../shared/models/translation.model';

export class ComplementOption {
  id: number;
  complementId: number;
  name: string;
  description: string;
  price: number = 0.0;
  status: Status;
  quantity: number = 0.0;

  // Aux view
  nameTranslations: Translation;
  descriptionTranslations: Translation;

  constructor(obj: any = {}) {
    Object.assign(this, obj);

    if (this.status != null && this.status['code'] == null) {
      this.status = UtilHelper.getEnumByCod(this.status, Status);
    } else if (this.status == null || this.status['code'] == null) {
      this.status = Status.ACTIVE;
    }
  }

  toJson(): any {
    const data: any = {
      complementId: this.complementId,
      id: this.id,
      name: this.name,
      description: this.description,
      price: this.price || 0,
      status: this.status['code'],
    };
    return data;
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/category/products/models/complement-options.model.ts